// src/sections/AdminImports.js
import React, { useEffect, useRef, useState } from "react";
import axios from "axios";

export default function AdminImports({ token }) {
  const [dataset, setDataset] = useState("full");
  const [periodo, setPeriodo] = useState("");
  const [file, setFile] = useState(null);
  const [msg, setMsg] = useState("");
  const [loading, setLoading] = useState(false);
  const [history, setHistory] = useState([]);
  const [loadingHistory, setLoadingHistory] = useState(false);

  const fileRef = useRef(null);

  const loadHistory = async () => {
    try {
      setLoadingHistory(true);
      const r = await axios.get("https://back.dataregion.com.co/api/admin/imports", {
        headers: { Authorization: "Bearer " + token },
      });
      setHistory(Array.isArray(r.data) ? r.data : []);
    } catch (e) {
      // opcional
    } finally {
      setLoadingHistory(false);
    }
  };

  useEffect(() => {
    if (!token) return;
    loadHistory();
  }, [token]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMsg("");

    if (!file) {
      setMsg("❌ Debes seleccionar un archivo .xlsx");
      return;
    }

    const form = new FormData();
    form.append("dataset", dataset);
    form.append("periodo", periodo.trim());
    form.append("file", file);

    try {
      setLoading(true);
      const r = await axios.post(
        "https://back.dataregion.com.co/api/admin/import/powerbi",
        form,
        {
          headers: {
            Authorization: "Bearer " + token,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      setMsg(`✅ Importación completada: ${r.data?.message || "OK"}`);

      setFile(null);
      setPeriodo("");
      if (fileRef.current) fileRef.current.value = "";

      await loadHistory();
    } catch (err) {
      setMsg("❌ Error: " + (err.response?.data?.message || err.message));
    } finally {
      setLoading(false);
    }
  };

  const StatusBadge = ({ status }) => {
    const s = String(status || "").toLowerCase();

    let label = status || "—";
    let cls = "badge";

    if (s === "success") {
      label = "Éxito";
      cls += " badge-success";
    } else if (s === "failed") {
      label = "Falló";
      cls += " badge-failed";
    } else if (s === "processing") {
      label = "Procesando";
      cls += " badge-processing";
    }

    return <span className={cls}>{label}</span>;
  };

  return (
    <div>
      <h3>Cargar datos (Excel)</h3>

      <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
        {msg && <p className="small" style={{ margin: 0 }}>{msg}</p>}
        {msg && (
          <button
            type="button"
            className="btn-ghost"
            onClick={() => setMsg("")}
            style={{ padding: "6px 10px" }}
          >
            Limpiar
          </button>
        )}
      </div>

      <form onSubmit={handleSubmit} className="institution-form">
        <label className="small">Tipo de carga</label>
        <select value={dataset} onChange={(e) => setDataset(e.target.value)}>
          <option value="full">Archivo completo (3 hojas)</option>
          <option value="stock">Stock</option>
          <option value="nuevas">Entradas (Nuevas)</option>
          <option value="cierres">Salidas (Cierres)</option>
        </select>

        <input
          type="text"
          placeholder="Periodo (ej: 2019-2023 o 2023-12)"
          value={periodo}
          onChange={(e) => setPeriodo(e.target.value)}
        />

        <input
          ref={fileRef}
          type="file"
          accept=".xlsx"
          onChange={(e) => setFile(e.target.files?.[0] || null)}
        />

        {file?.name && <p className="small">Archivo: {file.name}</p>}

        <button type="submit" className="btn" disabled={loading || !file}>
          {loading ? "Subiendo..." : "Subir Excel"}
        </button>
      </form>

      <hr style={{ margin: "18px 0" }} />

      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <h4 style={{ margin: 0 }}>Bitácora de subidas</h4>

        <button
          type="button"
          className="btn-ghost"
          onClick={loadHistory}
          disabled={loadingHistory}
          style={{ padding: "8px 12px" }}
        >
          {loadingHistory ? "Actualizando..." : "Actualizar bitácora"}
        </button>
      </div>

      {!history.length ? (
        <p className="small">No hay subidas registradas.</p>
      ) : (
        <div className="table-wrapper">
          <table className="inst-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Dataset</th>
                <th>Periodo</th>
                <th>Archivo</th>
                <th>Filas</th>
                <th>Estado</th>
                <th>Fecha</th>
              </tr>
            </thead>
            <tbody>
              {history.map((h) => (
                <tr key={h.id} className={h.isActive ? "active-batch" : ""}>
                  <td>{h.id}</td>
                  <td>{h.dataset}</td>
                  <td>{h.periodo || "—"}</td>
                  <td>{h.originalFileName || "—"}</td>
                  <td>{h.rowsInserted ?? "—"}</td>
                  <td>
                    <span className={`import-badge ${h.status}`}>
                      {h.status === "success" && "Éxito"}
                      {h.status === "failed" && "Falló"}
                      {h.status === "processing" && "Procesando"}
                    </span>
                  </td>
                  <td>{new Date(h.createdAt).toLocaleString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* ✅ CSS mínimo embebido (si prefieres, muévelo a tu CSS global) */}
      <style>{`
        .badge{
          display:inline-block;
          padding:4px 10px;
          border-radius:999px;
          font-size:12px;
          font-weight:600;
          border:1px solid rgba(0,0,0,.12);
        }
        .badge-success{ background: rgba(34,197,94,.12); border-color: rgba(34,197,94,.35); }
        .badge-failed{ background: rgba(239,68,68,.12); border-color: rgba(239,68,68,.35); }
        .badge-processing{ background: rgba(59,130,246,.12); border-color: rgba(59,130,246,.35); }
      `}</style>
    </div>
  );
}
